module.exports = __webpack_public_path__ + "static/media/night-icon.72acd6a6.svg";